import { formatDateTimeGmt } from './formatDateTimeGmt';

/** Consistent “Created when” display for data tables (list pages). */
export function formatCreatedWhen(iso: string | null | undefined): string {
  return formatDateTimeGmt(iso);
}
